import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import styles from './AiFlaggedBadge.module.css';

export interface AiFlaggedBadgeProps {
  tooltip?: string;
  testId?: string;
}

export function AiFlaggedBadge({ tooltip, testId }: AiFlaggedBadgeProps): React.ReactElement {
  return (
    <span
      className={styles.badge}
      title={tooltip ?? I18n.t(`${I18N_BASE}.general.aiFlaggedTooltip`)}
      data-testid={testId}
    >
      {I18n.t(`${I18N_BASE}.general.aiFlagged`)}
    </span>
  );
}

export default AiFlaggedBadge;
